/**
 * Created by cedricgodefroy on 18/07/2017.
 */
angular.module('FlexyBeautyApp.services').factory('DashboardStatView', ["$dialog", "ReportView", "DashboardSrv", "DashboardData", "Dashboard", "ReportModelData", "TaxMode", "gettextCatalog", "DashboardSchedulerView", "DashboardSchedulerData",
    function ($dialog, ReportView, DashboardSrv, DashboardData, Dashboard, ReportModelData, TaxMode, gettextCatalog, DashboardSchedulerView, DashboardSchedulerData) {
        var DashboardStatView = function (dashboard, dashboardIndex, functionSolutionActivated, startModelId) {
            this.dashboardIndex = dashboardIndex;
            this.reportsView = [];
            this.dashboardSchedulersView = [];
            this.id = null;
            this.title = this.defaultTitle;
            this.titleMouseover = false;
            this.titleFocus = false;
            this.editing = false;
            this.isFlexy = false;
            this.dashboardModel = dashboard;

            if (dashboard) {
                this.loadDataFrom(dashboard, functionSolutionActivated, startModelId);
            }
        };

        var myNewTable = gettextCatalog.getString("Mon nouveau tableau de bord");
        DashboardStatView.prototype.defaultTitle = myNewTable;

        DashboardStatView.prototype.loadDataFrom = function (datas, functionSolutionActivated, startModelId) {
            this.id = datas.id;
            this.title = datas.title;

            this.isFlexy = datas.isFlexy;

            var reports = angular.fromJson(datas.jsonDetail);

            this.reportsView = [];
            if (reports) {
                for (var i = 0; i < reports.length; i++) {
                    var reportModel = ReportModelData.getById(reports[i].reportModelId);
                    if (reportModel) {
                        var reportView = new ReportView(reportModel, reports[i].reportChanges, this.taxMode, functionSolutionActivated, startModelId);
                        this.reportsView.push(reportView);
                    }
                }
            }
            if (datas.dashboardSchedulers) {
                for (var i = 0; i < datas.dashboardSchedulers.length; i++) {
                    var dashboardSchedulerView = new DashboardSchedulerView(datas.dashboardSchedulers[i], DashboardSchedulerData.getIndexOf(datas.dashboardSchedulers[i]));
                    this.dashboardSchedulersView.push(dashboardSchedulerView);
                }
            }
        };

        DashboardStatView.prototype.addReport = function (reportView) {
            var cloneReport = reportView.getClone(),
                currentCategorieId = null,
                currentCategoryType = null;

            if (reportView.getDataSource().currentPath.length > 1) {
                currentCategorieId = reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].id;
            }
            if (reportView.getDataSource().currentPath.length > 1) {
                currentCategoryType = reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].constructor ? reportView.getDataSource().currentPath[reportView.getDataSource().currentPath.length - 1].constructor.name : null;
            }

            cloneReport.createDataSource(reportView.taxMode, currentCategorieId, currentCategoryType);
            cloneReport.getDataSource().loadPeriod(reportView.getDataSource().currentPeriod, reportView.getDataSource().selectedPastPeriod, reportView.getDataSource().taxMode);
            this.reportsView.push(cloneReport);
        };

        DashboardStatView.prototype.removeReport = function (reportView) {
            var indexToRemove = this.reportsView.indexOf(reportView);

            if (indexToRemove != -1) {
                this.reportsView.splice(indexToRemove, 1);
            }
        };

        DashboardStatView.prototype.moveRight = function (reportView) {
            var index = this.reportsView.indexOf(reportView);

            this.reportsView.splice(index, 1);

            this.reportsView.splice(index + 1, 0, reportView);

        };

        DashboardStatView.prototype.moveLeft = function (reportView) {
            var index = this.reportsView.indexOf(reportView);

            this.reportsView.splice(index, 1);
            this.reportsView.splice(index - 1, 0, reportView);

        };
        DashboardStatView.prototype.moveToIndex = function (indexOld, indexTarget) {
            if (indexOld >= 0 && indexOld < this.reportsView.length &&
                indexTarget >= 0 && indexTarget < this.reportsView.length && indexOld != indexTarget) {
                var reportView = this.reportsView[indexOld];
                this.reportsView.splice(indexOld, 1);
                this.reportsView.splice(indexTarget, 0, reportView);
            }
        };

        DashboardStatView.prototype.hasReport = function (reportView) {
            var hasReport = this.reportsView.indexOf(reportView) != -1 ? true : false;
            return hasReport;
        };

        DashboardStatView.prototype.getReport = function (reportId) {
            var reportsView = null;
            for (var i = 0; i < this.reportsView.length; i++) {
                if (this.reportsView[i].id === reportId) {
                    reportsView = this.reportsView[i];
                    break;
                }
            }
            return reportsView;
        };

        DashboardStatView.prototype.updateModel = function (endFunction) {
            var dashboard = this.getModel();

            if (dashboard == null) {
                dashboard = new Dashboard();
                this.dashboardIndex = DashboardData.getIndexOf(dashboard);
                this.dashboardModel = dashboard;
            }

            this.copyDataTo(dashboard);

            DashboardSrv.save(dashboard, endFunction);
        };

        DashboardStatView.prototype.copyDataTo = function (dashboard) {
            dashboard.title = this.title;

            var reports = new Array();

            for (var i = 0; i < this.reportsView.length; i++) {
                var userChanges = this.reportsView[i].getChanges();

                var report = {
                    reportModelId: this.reportsView[i].reportModelId,
                    reportChanges: userChanges
                }
                reports.push(report);
                this.reportsView[i].userChanges = userChanges;
            }

            dashboard.jsonDetail = angular.toJson(reports);
        };

        DashboardStatView.prototype.getModel = function () {
            if (this.dashboardIndex != -1) {
                return DashboardData.getByIndex(this.dashboardIndex);
            }
            return null;
        };

        DashboardStatView.prototype.removeModel = function () {
            var dashboard = this.getModel();
            if (dashboard != null)
                DashboardSrv.remove(dashboard);
        };

        DashboardStatView.prototype.reloadModel = function (functionSolutionActivated, startModelId) {
            var dashboard = this.getModel();
            if (dashboard != null) {
                this.loadDataFrom(dashboard, functionSolutionActivated, startModelId);
            }
        };

        DashboardStatView.prototype.isChanged = function () {
            if (this.dashboardModel) {
                var isReportChanged = false;

                var reportsFromDashboardModel = angular.fromJson(this.dashboardModel.jsonDetail);

                for (var i = 0; i < this.reportsView.length && isReportChanged === false; i++) {
                    isReportChanged = isReportChanged || this.reportsView[i].isChanged() || reportsFromDashboardModel[i] == null || (reportsFromDashboardModel[i] != null && reportsFromDashboardModel[i].reportModelId !== this.reportsView[i].reportModelId);
                }

                var isDashboardSchedulerChanged = false;

                for (var i = 0; i < this.dashboardSchedulersView.length && isDashboardSchedulerChanged === false; i++) {
                    isDashboardSchedulerChanged = isDashboardSchedulerChanged || this.dashboardSchedulersView[i].isChanged();
                }

                return (this.title != this.dashboardModel.title) ||
                    isReportChanged ||
                    isDashboardSchedulerChanged;
            } else {
                return true;
            }
        };

        DashboardStatView.prototype.isNavigationChanged = function () {
            var isNavigationChanged = false;
            for (var i = 0; i < this.reportsView.length; i++) {
                isNavigationChanged = isNavigationChanged || this.reportsView[i].isNavigationChanged();
            }
            return isNavigationChanged;
        };

        DashboardStatView.prototype.onTaxModeChange = function (newTaxMode) {
            this.taxMode = newTaxMode;
            for (var i = 0; i < this.reportsView.length; i++) {
                this.reportsView[i].getDataSource().changeTaxMode(this.taxMode);
            }
        };

        DashboardStatView.prototype.hasCurrencyReport = function (newTaxMode) {
            var hasCurrencyReport = false;
            for (var i = 0; i < this.reportsView.length; i++) {
                if (this.reportsView[i].typeOfData == 'currency') {
                    hasCurrencyReport = true;
                    break;
                }
            }
            return hasCurrencyReport;
        };

        DashboardStatView.prototype.removeDashboardScheduler = function (dashboardSchedulerView) {
            var index = this.dashboardSchedulersView.indexOf(dashboardSchedulerView);
            if (index != -1)
                this.dashboardSchedulersView.splice(index, 1);
        }

        return DashboardStatView;
    }
]);



// WEBPACK FOOTER //
// ./js/services/views/statistics/report/DashboardStatView.js